export default {
  // Worlds
  worldSeen: 'At the lakes',
  worldMuenchen: 'In Munich',
  worldBerge: 'In the mountains',
  worldKultur: 'Culture & history',
  worldGauting: 'Right in Gauting',

  // Hero
  exHeroLabel: 'Things to do',
  exHeroTitle: 'Today, the lake.\nTomorrow, the city.\nThe day after that, the Alps.',
  exHeroText: 'Around the Alpenhof, every day can feel different. Sometimes you head to the water, sometimes into town, sometimes towards the mountains.',

  // Section labels
  exSelectorPrompt: 'What appeals to you today?',
  exFinderTile: 'Day-out finder',
  exFinderSub: 'What are you in the mood for?',
  exShowAll: 'Show all destinations',
  exGridTitleAll: 'All destinations',
  exGridSubtitle: 'Pick a category above – or simply browse them all.',
  exCardCount: 'destinations',
  exCardZielePrefix: 'destinations',
  exShowMore: 'Show {{count}} more',
  exShowLess: 'Show less',
  exExpandPrompt: 'Tap for more details & insider tips',
  exMapLink: 'Open in Google Maps',
  exMoreInfo: 'More info',

  // Distance ticker
  exDistanceTitle: 'Everything is close by',
  distStarnberger: 'Lake Starnberg',
  distMuenchen: 'Munich main station',
  distAndechs: 'Andechs Monastery',
  distAmmersee: 'Lake Ammersee',
  distWuermtal: 'Würmtal valley',
  distAlpen: 'Bavarian Alps',
  distGauting: 'Gauting town centre',
  time15min: '15 min',
  time25min: '25 min',
  time30min: '30 min',
  time60min: '60 min',
  timeDirect: 'On site',

  // External programme links
  linkProgramNymphenburg: 'Nymphenburg programme',
  linkProgramPinakothek: 'Pinakothek programme',
  linkProgramBuchheim: 'Buchheim Museum programme',
  linkProgramDeutschesMuseum: 'Deutsches Museum programme',
  linkProgramBosco: 'BOSCO programme',

  // CTA
  exCtaLabel: 'Your stay at the Alpenhof',
  exCtaTitle: 'So many trips. So close to the hotel.',
  exCtaText: 'Secure your favourite dates – we look forward to showing you the most beautiful sides of the region.',
  exCtaButton: 'Choose a room',

  // Mood Finder
  moodKicker: 'Day-out finder',
  moodTitle: 'What are you in the mood for?',
  moodSubtitle: 'Three quick questions – and we’ll suggest two perfect destinations.',
  moodQ1: 'How energetic are you feeling today?',
  moodQ1Low: '😴 Rather relaxed',
  moodQ1Mid: '🚶 A bit of both – I enjoy a walk',
  moodQ1High: '🏃 Plenty – I want to get out and do something!',
  moodQ2: 'What appeals to you more?',
  moodQ2Nature: '🌿 Nature & calm',
  moodQ2Culture: '🏛️ Culture & history',
  moodQ2Food: '🍺 Food & company',
  moodQ3: 'How far would you like to go?',
  moodQ3Near: '🚶 Right here in town',
  moodQ3Medium: '🚗 Up to 30 minutes',
  moodQ3Far: '🗺️ Further afield',
  moodResultsLead: 'Our two recommendations for you today:',
  moodTip1: 'Suggestion 1',
  moodTip2: 'Suggestion 2',
  moodMapLink: 'View on map',
  moodReset: 'Try again',

  // Excursions (visible items)
  ex1Title: 'Lake Starnberg',
  ex1Tagline: 'Bavaria’s most beautiful lake',
  ex1Mood: '🌊 Pure relaxation',
  ex1Duration: '15 min',

  ex2Title: 'Lake Ammersee',
  ex2Tagline: 'Open shores, water and wind',
  ex2Mood: '⛵ Sailing & soul-soothing',
  ex2Duration: '25 min',

  ex3Title: 'Visit Roseninsel',
  ex3Tagline: 'The little island in the lake',
  ex3Mood: '🌹 Royal atmosphere',
  ex3Duration: '20 min',

  ex4Title: 'A walk to the Votive Chapel in Berg',
  ex4Tagline: 'An evocative lakeside walk',
  ex4Mood: '⛪ Atmospheric & historic',
  ex4Duration: '15 min',

  ex5Title: 'A stroll through Lenné Park in Feldafing',
  ex5Tagline: 'Old trees and lake views',
  ex5Mood: '🌳 Park stroll',
  ex5Duration: '20 min',

  ex6Title: 'A boat ride across Lake Starnberg',
  ex6Tagline: 'Discover the shores from the water',
  ex6Mood: '⛴️ A view from the water',
  ex6Duration: '15 min',

  ex7Title: 'Boat trip on Lake Ammersee',
  ex7Tagline: 'A summer day on the water',
  ex7Mood: '🚢 Relaxed & with great views',
  ex7Duration: '25 min',

  ex8Title: 'Andechs Monastery',
  ex8Tagline: 'Holy mountain & monastery beer',
  ex8Mood: '🍺 Culture meets indulgence',
  ex8Duration: '30 min',

  ex9Title: 'Swim, paddleboard or simply relax at Lake Wörthsee',
  ex9Tagline: 'The lake to jump into',
  ex9Mood: '🏊 Summer feeling',
  ex9Duration: '15 min',

  ex10Title: 'Walk the Wörthsee shore loop',
  ex10Tagline: 'Easy walking, quiet lakeside moments',
  ex10Mood: '🚶 A relaxed loop',
  ex10Duration: '12 min',

  ex11Title: 'Combine Lake Pilsensee with Seefeld Castle',
  ex11Tagline: 'Water and culture combined',
  ex11Mood: '🏰 Landscape & culture',
  ex11Duration: '20 min',

  ex12Title: 'Lake Weßling',
  ex12Tagline: 'Small, quiet and unspoilt',
  ex12Mood: '🌿 A peaceful loop',
  ex12Duration: '15 min',

  ex13Title: 'Munich – city centre',
  ex13Tagline: 'Experience the Bavarian capital',
  ex13Mood: '🏙️ Shop, stroll, marvel',
  ex13Duration: '25 min S-Bahn',

  ex14Title: 'Nymphenburg Palace',
  ex14Tagline: 'The Versailles of Bavaria',
  ex14Mood: '👑 Splendour & park air',
  ex14Duration: '30 min',

  ex15Title: 'Munich’s old town',
  ex15Tagline: 'Historic squares and lively lanes',
  ex15Mood: '🏛️ A classic',
  ex15Duration: '25 min',

  ex16Title: 'Wander through Viktualienmarkt',
  ex16Tagline: 'Colours, scents and Munich life',
  ex16Mood: '🥨 Moments of indulgence',
  ex16Duration: '25 min',

  ex18Title: 'A walk in the English Garden',
  ex18Tagline: 'In the heart of Munich, in the heart of green',
  ex18Mood: '🌳 City visit, with fresh air',
  ex18Duration: '25 min',

  ex20Title: 'Bavarian Alps',
  ex20Tagline: 'When you want something grander',
  ex20Mood: '⛰️ Pure summit bliss',
  ex20Duration: '60 min',

  ex21Title: 'Munich Pinakothek museums',
  ex21Tagline: 'World-class art, 25 min away',
  ex21Mood: '🎨 Art & coffee',
  ex21Duration: '25 min S-Bahn',

  ex22Title: 'Visit the Buchheim Museum',
  ex22Tagline: 'Art, architecture and a lakeside setting',
  ex22Mood: '🎨 Inspiring hours',
  ex22Duration: '25 min',

  ex23Title: 'Discover the Lake Starnberg Museum',
  ex23Tagline: 'History and everyday life by the lake',
  ex23Mood: '🏛️ Vivid & charming',
  ex23Duration: '15 min',

  ex24Title: 'Museums, exhibitions and culture in Munich',
  ex24Tagline: 'A city full of cultural delights',
  ex24Mood: '🎭 Cultural pleasure',
  ex24Duration: '25 min',

  ex25Title: 'See a film at Breitwand Gauting',
  ex25Tagline: 'A charming arthouse cinema right in town',
  ex25Mood: '🎬 A relaxed evening',
  ex25Duration: 'On site',

  ex26Title: 'Würmtal trail: to Grubmühlerfeld',
  ex26Tagline: 'Right from the hotel into nature',
  ex26Mood: '🌲 On your doorstep',
  ex26Duration: 'On site',

  ex28Title: 'Lake Eibsee',
  ex28Tagline: 'A mountain lake at the foot of the Zugspitze',
  ex28Mood: '💎 Breathtakingly beautiful',
  ex28Duration: '60 min',

  ex29Title: 'Ostersee',
  ex29Tagline: 'A quiet chain of lakes in the foothills',
  ex29Mood: '🌅 Calm & nature',
  ex29Duration: '40 min',

  ex34Title: 'Loop walk around Lake Ostersee',
  ex34Tagline: 'A walk along the chain of lakes',
  ex34Mood: '🚶 A quiet loop',
  ex34Duration: '40 min',

  ex30Title: 'Lake Staffelsee',
  ex30Tagline: 'An alpine-foothills idyll with little islands',
  ex30Mood: '🐄 Pastoral lakeside',
  ex30Duration: '50 min',

  ex31Title: 'Midgardhaus Tutzing',
  ex31Tagline: 'Lake views with history',
  ex31Mood: '🏡 Lake views & history',
  ex31Duration: '25 min',

  ex32Title: 'Würmtal trail: to Leutstetten',
  ex32Tagline: 'A countryside idyll on the doorstep',
  ex32Mood: '🌾 Rural idyll',
  ex32Duration: 'On site',

  ex36Title: 'Lake Schliersee',
  ex36Tagline: 'Authentic, peaceful, framed by mountains',
  ex36Mood: '🌿 Authentic Bavaria',
  ex36Duration: '55 min',

  ex37Title: 'Deutsches Museum',
  ex37Tagline: 'The world’s largest museum of technology',
  ex37Mood: '🔬 Marvel & discover',
  ex37Duration: '25 min S-Bahn',

  ex38Title: 'Zugspitze',
  ex38Tagline: 'Germany’s highest peak',
  ex38Mood: '⛰️ Pure summit bliss',
  ex38Duration: '80 min',

  ex46Title: 'Ettal Monastery',
  ex46Tagline: 'Baroque grandeur in the Ammer valley',
  ex46Mood: '🏛️ Calm & contemplation',
  ex46Duration: '65 min',

  ex48Title: 'Linderhof Palace',
  ex48Tagline: 'Ludwig’s smallest – and favourite – palace',
  ex48Mood: '👑 Royal dreams',
  ex48Duration: '70 min',

  ex54Title: 'The Holy Petersberg',
  ex54Tagline: 'A basilica on one of Bavaria’s holy mountains',
  ex54Mood: '🙏 Calm & spirituality',
  ex54Duration: '60 min',

  ex56Title: 'BOSCO Gauting',
  ex56Tagline: 'Culture right at the hotel’s doorstep',
  ex56Mood: '🎭 Local culture',
  ex56Duration: 'On site',

  // Tips, descriptions, highlights
  ex1Tip: 'Tip: Boat rental right on the shore in Starnberg – no licence required!',
  ex1Desc: 'Crystal-clear water, gentle hills, an alpine panorama on the horizon. Lake Starnberg is just 15 minutes away and feels like a holiday within a holiday.',
  ex1H1: 'Boat trip', ex1H2: 'Swimming', ex1H3: 'Lakeside promenade', ex1H4: 'Sunsets',

  ex2Tip: 'Tip: Take the ferry from Herrsching to Andechs – beer and views included.',
  ex2Desc: 'Slightly less famous than Lake Starnberg, but all the more authentic. Wide shores, sailing boats, fresh fish – and Andechs Monastery rising right above.',
  ex2H1: 'Sailing', ex2H2: 'Ferry', ex2H3: 'Fish restaurants', ex2H4: 'Nature reserve',

  ex3Tip: 'Tip: The crossing by traditional rowboat is an experience in itself – only on fair-weather days.',
  ex3Desc: 'A quiet island full of history, roses and royal atmosphere – reachable by traditional rowboat and ideal for a special day out.',
  ex3H1: 'Rose garden', ex3H2: 'Rowboat crossing', ex3H3: 'Royal villa', ex3H4: 'Calm',

  ex4Tip: 'Tip: The cross in the water marks the spot where King Ludwig II died – a moving place.',
  ex4Desc: 'An evocative walk with lake views and history: to the chapel in the park at Berg and on to the cross in the water.',
  ex4H1: 'Votive Chapel', ex4H2: 'Cross in the water', ex4H3: 'Parkland', ex4H4: 'Lake views',

  ex5Tip: 'Tip: The park leads straight to the lakeshore – perfect for combining culture and nature.',
  ex5Desc: 'Old trees, broad paths and elegant calm make Lenné Park a wonderful place for a lakeside walk.',
  ex5H1: 'Historic park', ex5H2: 'Old trees', ex5H3: 'Lake views', ex5H4: 'Calm',

  ex6Tip: 'Tip: On a clear day, the Alps look especially impressive from the boat.',
  ex6Desc: 'From the water, the lake reveals itself at its best: villas, shorelines, open vistas and, on clear days, even an alpine panorama.',
  ex6H1: 'Boat ride', ex6H2: 'Lakeside villas', ex6H3: 'Alpine panorama', ex6H4: 'Wide views',

  ex7Tip: 'Tip: The round trip from Herrsching is particularly lovely and stops at all the highlights.',
  ex7Desc: 'Open water and a real sense of summer: a boat trip on Lake Ammersee is relaxed, scenic and wonderfully easy.',
  ex7H1: 'Boat trip', ex7H2: 'Wide views', ex7H3: 'Summer feeling', ex7H4: 'Scenic',

  ex8Tip: 'Tip: The monastery tavern – beer on tap and a view across Lake Ammersee.',
  ex8Desc: 'First the water, then up to the monastery: Andechs combines panorama, history and Bavarian hospitality in a particularly lovely way.',
  ex8H1: 'Monastery church', ex8H2: 'Monastery beer', ex8H3: 'Panorama', ex8H4: 'Pilgrimage site',

  ex9Tip: 'Tip: Paddleboard rental right on the shore – perfect for beginners too.',
  ex9Desc: 'Bright, summery and relaxed: Lake Wörthsee is ideal for swimming, paddleboarding or simply a few quiet hours by the water.',
  ex9H1: 'Swimming', ex9H2: 'Paddleboarding', ex9H3: 'Relaxation', ex9H4: 'Summer',

  ex10Tip: 'Tip: The loop is about 8 km long and follows beautiful shoreline scenery.',
  ex10Desc: 'A lovely walk for easy movement and quiet lakeside moments – perfect for a calm, outdoorsy start to the day.',
  ex10H1: 'Loop walk', ex10H2: 'Lakeside moments', ex10H3: 'Nature', ex10H4: 'Easy',

  ex11Tip: 'Tip: Seefeld has small shops and cafés – perfect for a relaxed break.',
  ex11Desc: 'First the water, then on to Seefeld Castle: a day out with landscape, little shops, culture and a relaxed atmosphere.',
  ex11H1: 'Lake Pilsensee', ex11H2: 'Seefeld Castle', ex11H3: 'Culture', ex11H4: 'Relaxation',

  ex12Tip: 'Tip: The lake is small enough for a quick loop – ideal in between.',
  ex12Desc: 'Small, peaceful and wonderfully unfussy: Lake Weßling is perfect for a quick lap around the water in between.',
  ex12H1: 'Small lake', ex12H2: 'Loop walk', ex12H3: 'Calm', ex12H4: 'Nature',

  ex13Tip: 'Tip: Take the S6 from Gauting – straight into the city centre, no changes.',
  ex13Desc: 'Glockenspiel, Weisswurst (Bavaria’s white sausage), world-class museums and some of Europe’s best beer gardens. Munich is just 25 minutes away – and still feels like a journey of its own.',
  ex13H1: 'Marienplatz', ex13H2: 'Viktualienmarkt', ex13H3: 'English Garden', ex13H4: 'Shopping',

  ex14Tip: 'Tip: Come early – at first light, the park is almost yours alone.',
  ex14Desc: 'Baroque grandeur, sweeping parkland and canals to wander along. Nymphenburg Palace is the Versailles of Bavaria – and the park is free.',
  ex14H1: 'Palace park', ex14H2: 'Canals', ex14H3: 'Marstall (Royal Stables) Museum', ex14H4: 'Cafés',

  ex15Tip: 'Tip: Early in the morning the old town is at its most beautiful – without the crowds.',
  ex15Desc: 'Historic squares, beautiful façades and lively lanes make the old town a classic for a perfect day in Munich.',
  ex15H1: 'Historic squares', ex15H2: 'Façades', ex15H3: 'Lanes', ex15H4: 'Atmosphere',

  ex16Tip: 'Tip: Try the fresh Obatzda (a Bavarian cheese spread) stalls – a true Bavarian classic!',
  ex16Desc: 'Colours, scents and the Munich way of life: Viktualienmarkt is ideal for a relaxed city stroll with moments of indulgence.',
  ex16H1: 'Market', ex16H2: 'Indulgence', ex16H3: 'Atmosphere', ex16H4: 'Munich vibe',

  ex18Tip: 'Tip: The Chinese Tower is a lovely stop – with its own beer garden.',
  ex18Desc: 'Lots of green, lots of space, and yet entirely relaxed in the middle of Munich – perfect for a city visit with air and ease.',
  ex18H1: 'Greenery', ex18H2: 'Wide spaces', ex18H3: 'Relaxation', ex18H4: 'Heart of Munich',

  ex20Tip: 'Tip: The Zugspitze cogwheel railway – Germany’s highest point.',
  ex20Desc: 'An hour’s drive, a different world. The Alps offer hiking paradises in summer, ski resorts in winter – and panoramas year-round that leave you speechless.',
  ex20H1: 'Zugspitze', ex20H2: 'Garmisch', ex20H3: 'Hiking', ex20H4: 'Skiing',

  ex21Tip: 'Tip: On Sundays, admission is just €1 – yes, really.',
  ex21Desc: 'Three Pinakothek museums, one art quarter. From Rubens to Warhol – Munich has one of the densest museum landscapes in Europe. All within 25 minutes.',
  ex21H1: 'Old Pinakothek', ex21H2: 'Modern art', ex21H3: 'Museum shop', ex21H4: 'Café',

  ex22Tip: 'Tip: The museum is right on Lake Starnberg – perfect to combine with a walk.',
  ex22Desc: 'Art, architecture and a lakeside setting come together here – a special place for inspiring hours indoors.',
  ex22H1: 'Art', ex22H2: 'Architecture', ex22H3: 'Lakeside setting', ex22H4: 'Culture',

  ex23Tip: 'Tip: The museum also covers the story of King Ludwig II – well worth a visit.',
  ex23Desc: 'For anyone who wants to get to know the region better, this museum brings local history, everyday life and lakeside life to life in a vivid, charming way.',
  ex23H1: 'History', ex23H2: 'Everyday life', ex23H3: 'Lakeside life', ex23H4: 'Regional',

  ex24Tip: 'Tip: The Deutsches Museum is the world’s largest museum of technology – a full day is barely enough.',
  ex24Desc: 'For a deeper cultural fix, Munich offers great museums, exhibitions and many lovely evenings out in the city.',
  ex24H1: 'Museums', ex24H2: 'Exhibitions', ex24H3: 'Culture', ex24H4: 'Evening programme',

  ex25Tip: 'Tip: The Breitwand is a charming arthouse cinema with a fine selection of films.',
  ex25Desc: 'A film evening with a pleasant atmosphere and a good line-up – quiet, close by and just right for a relaxed evening.',
  ex25H1: 'Cinema', ex25H2: 'Atmosphere', ex25H3: 'Close by', ex25H4: 'Evening programme',

  ex26Tip: 'Tip: The Mühltal valley is especially beautiful in autumn – with colourful leaves and quiet paths.',
  ex26Desc: 'Water, trees and lots of calm: the Würmtal trail to Grubmühlerfeld leads straight from the hotel into one of the loveliest landscapes in the area.',
  ex26H1: 'Würmtal', ex26H2: 'Grubmühlerfeld', ex26H3: 'Calm', ex26H4: 'Nature',

  ex28Tip: 'Tip: Set off early – it gets busy.',
  ex28Desc: 'Turquoise water, tiny islands and the Zugspitze massif rising directly above: Lake Eibsee is one of the most beautiful lakes in Germany – and just over an hour away.',
  ex28H1: 'Turquoise water', ex28H2: 'Zugspitze view', ex28H3: 'Loop trail', ex28H4: 'Swimming',

  ex29Tip: 'Tip: The loop trail around Ostersee is especially beautiful – natural and rarely crowded.',
  ex29Desc: 'Still water, expansive nature and barely a soul in sight: Ostersee in the alpine foothills is an insider tip for anyone seeking calm and untouched landscape.',
  ex29H1: 'Loop trail', ex29H2: 'Nature reserve', ex29H3: 'Calm', ex29H4: 'Evening light',

  ex34Tip: 'Tip: The trail is well signposted and runs through a beautiful nature reserve.',
  ex34Desc: 'A natural loop trail through moor, forest and right along the lakeshore – the Ostersee circuit is ideal for anyone who wants to walk and find real silence.',
  ex34H1: 'Loop trail', ex34H2: 'Moorland', ex34H3: 'Forest', ex34H4: 'Calm',

  ex30Tip: 'Tip: Combine the lake with a visit to the picturesque town of Murnau.',
  ex30Desc: 'Wide lakefronts, alpine views and the proximity to charming Murnau make Staffelsee a wonderful destination in the alpine foothills.',
  ex30H1: 'Wide views', ex30H2: 'Alpine foothills', ex30H3: 'Murnau', ex30H4: 'Nature reserve',

  ex31Tip: 'Tip: The lakeside path along Lake Starnberg in Tutzing is well worth a stroll.',
  ex31Desc: 'The Midgardhaus in Tutzing is an impressive Art Nouveau building right on Lake Starnberg – a lovely destination for a walk with history and lake views.',
  ex31H1: 'Art Nouveau', ex31H2: 'Lake views', ex31H3: 'Tutzing', ex31H4: 'Lakeside path',

  ex32Tip: 'Tip: The path to Leutstetten runs idyllically along the Würm – ideal for a relaxed morning or evening loop.',
  ex32Desc: 'Along the Würm river through quiet meadows and woods to the village of Leutstetten – a wonderful walk straight from the hotel.',
  ex32H1: 'Würmtal', ex32H2: 'Leutstetten', ex32H3: 'Calm', ex32H4: 'Nature',

  ex36Tip: 'Tip: From Schliersee, you can reach the Schliersberg Alm via a short trail – well worth it! Also well worth a visit: the Markus Wasmeier open-air museum and the Slyrs whisky distillery – we serve their whisky here at the hotel, too.',
  ex36Desc: 'Lake Schliersee lies quiet and unspoilt amid the alpine foothills – less well-known than Tegernsee, but all the more authentic and natural.',
  ex36H1: 'Calm', ex36H2: 'Mountain views', ex36H3: 'Swimming', ex36H4: 'Hiking',

  ex37Tip: 'Tip: Plan at least half a day for a proper visit – the museum is huge.',
  ex37Desc: 'The Deutsches Museum on the Isar Island is the world’s largest museum of technology and natural sciences – with more than 73,000 exhibits across eleven floors.',
  ex37H1: 'Technology', ex37H2: 'Science', ex37H3: 'Interactive', ex37H4: 'Fun for everyone',

  ex38Tip: 'Tip: Take the cogwheel railway from Garmisch – at the top, a breathtaking panorama across three countries awaits.',
  ex38Desc: 'Up Germany’s highest peak by cogwheel railway or cable car: at 2,962 m, the Zugspitze offers a panoramic view across Bavaria, Austria and Switzerland.',
  ex38H1: 'Cogwheel railway', ex38H2: 'Summit panorama', ex38H3: 'Glacier', ex38H4: 'Highest point',

  ex46Tip: 'Tip: The monastery’s own cheese and Ettal Monastery liqueur are well-known specialities – available right in the monastery shop.',
  ex46Desc: 'The Benedictine monastery of Ettal is set among the Ammergau Alps – with its impressive Baroque church, its own brewery and monastic calm.',
  ex46H1: 'Baroque church', ex46H2: 'Monastery shop', ex46H3: 'Mountain panorama', ex46H4: 'History',

  ex48Tip: 'Tip: The grounds, with their Venus Grotto and Moorish Pavilion, are as worth seeing as the palace itself.',
  ex48Desc: 'Linderhof was the only palace King Ludwig II completed himself – surrounded by dreamlike grounds with a Venus Grotto, water features and exotic pavilions.',
  ex48H1: 'Palace', ex48H2: 'Venus Grotto', ex48H3: 'Grounds', ex48H4: 'King Ludwig II',

  ex54Tip: 'Tip: The climb to the basilica is short and runs through a wonderful foothill landscape – a true place of strength.',
  ex54Desc: 'Petersberg is one of the oldest pilgrimage sites in Bavaria – a quiet place of strength with a Romanesque basilica and far-reaching views over the foothills.',
  ex54H1: 'Basilica', ex54H2: 'Place of strength', ex54H3: 'Panoramic views', ex54H4: 'Calm',

  ex56Tip: 'Tip: Check the BOSCO programme before you arrive – concerts, theatre and readings often sell out fast.',
  ex56Desc: 'BOSCO is Gauting’s cultural centre – with a varied programme of concerts, theatre, readings and films. Just a few minutes’ walk from the hotel.',
  ex56H1: 'Concerts', ex56H2: 'Theatre', ex56H3: 'Readings', ex56H4: 'Local',
};
